import React, {useCallback} from 'react';

import {Skeleton} from 'src/components/skeleton';

import {CheckBox} from '@pb/kit-component-checkbox';
import {FormSection} from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';

import {PasswordSharingWarningSkeleton} from './password-sharing-warning.skeleton';
import {SendPasswordSharingWarningEmail} from './send-password-sharing-warning';

import type {Dispatch, SetStateAction} from 'react';
import type {UserLoginStateResponse} from 'src/openapi/admin/models/UserLoginStateResponse';
import type {CheckBoxChangeData} from 'src/typedef';

type Props = {
    isLoading: boolean,
    userId: number,
    userLoginPreconditions: UserLoginStateResponse,
    onChange: Dispatch<SetStateAction<UserLoginStateResponse>>,
    disabled: boolean,

    onFieldChange: (parameterName: string) => void,
};

const LABEL = 'Show Password Sharing Warning at next login';

export const PasswordSharingWarning = (props: Props) => {
    const {isLoading, userId, userLoginPreconditions, onChange, disabled, onFieldChange} = props;
    const setMustChangePassword = useCallback((changeData: CheckBoxChangeData) => {
        onFieldChange(LABEL);
        onChange(prevState => ({
            ...prevState,
            [changeData.name]: changeData.event.currentTarget.checked,
        }));
    }, [onChange, onFieldChange]);

    return (
        <Skeleton shown={isLoading} view={<PasswordSharingWarningSkeleton/>}>
            <FormSection headline="Password Sharing Warning">
                <Group direction="v">
                    <CheckBox
                        disabled={disabled}
                        name="showPasswordSharingWarning"
                        label="Show Password Sharing Warning at next login"
                        checked={userLoginPreconditions.showPasswordSharingWarning}
                        onCheckBoxChange={setMustChangePassword}
                    />
                    <SendPasswordSharingWarningEmail userId={userId} onFieldChange={onFieldChange} disabled={disabled}/>
                </Group>
            </FormSection>
        </Skeleton>
    );
};
